import { ReactNode, useState, useRef } from 'react'

import { instanceOfAnchorRef } from 'api/utils'
import { Text } from 'components/atoms/text'
import { TableOfContentItem } from 'interfaces/types'
import MinusIcon from 'public/svg/minus.svg'
import PlusIcon from 'public/svg/plus.svg'
import { useIntl } from 'react-intl'

import {
  StyledSources,
  StyledHeading,
  StyledExpandableContainer,
  StyledIconText,
} from './index.styled'

export type Source = string

export type Props = {
  size?: 'lg' | 'md' | 'sm'
  className?: string
  sources: Array<TableOfContentItem>
  heading?: ReactNode
  isMobile?: boolean
}

const StructuredSources = ({
  className,
  size = 'md',
  sources = [],
  heading,
  isMobile,
}: Props) => {
  const { formatMessage: f } = useIntl()
  const [expand, setExpand] = useState(true)
  const sourcesRef = useRef<HTMLDivElement>(null)

  return (
    <StyledSources className={className} data-size={size}>
      <StyledHeading
        onClick={() => {
          setExpand((e) => !e)
        }}
      >
        <StyledIconText
          size={size}
          iconPosition="right"
          icon={
            expand ? (
              <MinusIcon
                className="source-icon"
                width={isMobile ? '16' : '24'}
              />
            ) : (
              <PlusIcon
                className="source-icon"
                width={isMobile ? '16' : '24'}
              />
            )
          }
        >
          <span>{heading || f({ id: 'articlePage.structuredSources' })}</span>
        </StyledIconText>
      </StyledHeading>
      <StyledExpandableContainer
        data-expand={expand}
        style={
          expand
            ? {
                height: sourcesRef.current?.clientHeight,
              }
            : {}
        }
      >
        <div className={'source-wrapper'} ref={sourcesRef}>
          <ul>
            {sources &&
              sources.map((content, index) => {
                if (!content) return null
                return instanceOfAnchorRef(content) ? (
                  <li>
                    <a
                      key={`structure-sources-${index}`}
                      href={`#${content.id}`}
                      className=""
                    >
                      <Text type="subtitle-3" color="#2661AD">
                        {content.label}
                      </Text>
                    </a>
                  </li>
                ) : (
                  <li>
                    <a className="">{content}</a>
                  </li>
                )
              })}
          </ul>
        </div>
      </StyledExpandableContainer>
    </StyledSources>
  )
}

export { StructuredSources }
